import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import store, { RootState } from '../index';
import SubstanceService from 'services/substance';
import { StatusCode } from 'libs/HTTP/constant';

interface SubstanceStore {
  list: any[];
}
const DefalutData: SubstanceStore = {
  // 实体变量列表
  list: []
};

const slice = createSlice({
  name: 'substance',
  initialState: DefalutData,
  reducers: {
    setSubstance: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...state, list: payload };
    }
  }
});
export const substanceStore = (state: RootState) => state.substance;
export const { setSubstance } = slice.actions;
export default slice.reducer;

// 获取实体变量列表
export const getSubstanceList = async (data: any = {}) => {
  let res: any = await SubstanceService.getList({
    pageNo: 1,
    pageSize: 999999999
  });
  if (res.code === StatusCode.success) {
    let list = res.data?.list || [];
    // 设置实体变量列表
    store.dispatch(setSubstance(list));
  }
  return Promise.resolve(res);
};
